module.exports = __webpack_public_path__ + "img/1_ralph.cbc63273.jpg";